<template>
  <div id="contactSection" class="white">
    <h4>Contactpersoon</h4>
    <b-img
      v-if="job.Contact.Image.length >= 1"
      thumbnail
      loading="lazy"
      id="contactImage"
      fluid
      v-bind:src="job.Contact.Image"
      alt="Image 1"
      class="pb-1 pt-1 rounded"
    ></b-img>
    <b-img
      v-else
      thumbnail
      rounded
      id="contactImage"
      src="../../assets/personPlaceholder.png"
      fluid
      alt="Responsive image"
    ></b-img>
    <h5>{{ job.Contact.FirstName }} {{ job.Contact.LastName }}</h5>
    <p>{{ job.Contact.Description }}</p>
    <p class="contactText">
      <font-awesome-icon class="contactIcon" icon="envelope" />
      <span>{{ job.Contact.EmailAddress }}</span>
    </p>
    <p
      class="contactText"
      id="phoneNumber"
      @click="CallNumber(job.Contact.PhoneNumber)"
    >
      <font-awesome-icon class="contactIcon" icon="phone" />
      <span>{{ job.Contact.PhoneNumber }}</span>
    </p>
  </div>
</template>

<script>
export default {
  name: "DesktopContactSection",
  components: {},
  props: {
    job: Object,
  },
  methods: {
    CallNumber: function (phoneNumber) {
      location.href = "tel:" + phoneNumber;
    },
  },
};
</script>

<style scoped>
h4 {
  padding-bottom: 24px;
}
#contactImage {
  height: 240px;
  display: block;
  margin-top: 20px;
  margin-right: auto;
  margin-bottom: 20px;
  margin-left: auto;
}
.contactText {
  margin-bottom: 0px;
}
.contactIcon {
  margin-right: 10px;
}
#phoneNumber:hover {
  text-decoration: underline;
  cursor: pointer;
}
#contactSection {
  margin-top: 2px;
  padding: 20px;
}
</style>